"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex justify-end" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_4 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_9 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const Form_1 = require("../../components/Form");
const UserRequest_1 = __importDefault(require("../../stores/user/UserRequest"));
const toastStore_1 = require("../../stores/toast/toastStore");
const userStore_1 = require("../../stores/user/userStore");
const userGroupStore_1 = require("../../stores/userGroup/userGroupStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminUsers',
    setup(__props) {
        var _a, _b, _c;
        const T = (0, vue_3.inject)("Translator");
        const router = (0, vue_router_1.useRouter)();
        const userStore = (0, userStore_1.useUserStore)();
        const userGroupStore = (0, userGroupStore_1.useUserGroupStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const modalIsOpen = (0, vue_3.ref)(false);
        const errorMessage = (0, vue_3.ref)("");
        const userRequest = (0, vue_3.ref)(new UserRequest_1.default());
        const selectedUser = (0, vue_3.ref)(null);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(false);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const plainPasswordConfirmation = (0, vue_3.ref)("");
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = T === null || T === void 0 ? void 0 : T.trans("id", "ID", "users")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "email",
                label: (_b = T === null || T === void 0 ? void 0 : T.trans("email", "Email", "users")) !== null && _b !== void 0 ? _b : "Email",
                value: "email",
                filterable: true,
                sortable: true,
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const userGroupsListFields = (0, vue_3.ref)([
            {
                key: "name",
                label: (_c = T === null || T === void 0 ? void 0 : T.trans("user_group", "User Group", "users")) !== null && _c !== void 0 ? _c : "User Group",
                value: "name",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const userQuery = (0, vue_3.computed)(() => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        (0, vue_3.onBeforeUnmount)(() => {
            userStore.reset();
        });
        (0, vue_3.onBeforeMount)(() => {
            userStore
                .getUsers(router, userQuery.value)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            userGroupStore
                .getUserGroups(router)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        });
        (0, vue_3.watchEffect)(() => {
            userStore
                .getUsers(router, userQuery.value)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        });
        const openCreateUserModal = () => {
            userRequest.value = new UserRequest_1.default();
            selectedUser.value = null;
            modalIsOpen.value = true;
        };
        const openUpdateUserModal = (user) => {
            selectedUser.value = user;
            userRequest.value = new UserRequest_1.default(null, user.email, 
            //@ts-ignore
            user.groups.map((userGroup) => userGroup["@id"]), user.extraEmails);
            modalIsOpen.value = true;
        };
        const deleteUser = (user) => {
            if (!confirm(T === null || T === void 0 ? void 0 : T.trans("delete_user_confirm", "Are you sure?", "users"))) {
                return;
            }
            errorMessage.value = "";
            userStore
                .deleteUser(router, user.id)
                .then(() => {
                userStore.reset();
                userStore
                    .getUsers(router, userQuery.value)
                    .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        const createUser = () => {
            var _a;
            errorMessage.value = "";
            if (userRequest.value.plainPassword !== plainPasswordConfirmation.value) {
                errorMessage.value =
                    (_a = T === null || T === void 0 ? void 0 : T.trans("passwords_not_match", "Given password and the confirmation does not match.", "users")) !== null && _a !== void 0 ? _a : "Given password and the confirmation does not match";
                return;
            }
            userStore
                .createUser(router, userRequest.value)
                .then(() => {
                modalIsOpen.value = false;
                userStore.reset();
                page.value = 1;
                userStore
                    .getUsers(router, userQuery.value)
                    .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        const updateUser = () => {
            var _a, _b;
            errorMessage.value = "";
            if (userRequest.value.plainPassword !== null &&
                userRequest.value.plainPassword !== "" &&
                userRequest.value.plainPassword !== plainPasswordConfirmation.value) {
                errorMessage.value =
                    (_a = T === null || T === void 0 ? void 0 : T.trans("passwords_not_match", "Given password and the confirmation does not match.", "users")) !== null && _a !== void 0 ? _a : "Given password and the confirmation does not match";
                return;
            }
            if (selectedUser.value === null) {
                errorMessage.value =
                    (_b = T === null || T === void 0 ? void 0 : T.trans("user_not_selected", "User not selected", "users")) !== null && _b !== void 0 ? _b : "User not selected";
                return;
            }
            if (userRequest.value.plainPassword === "") {
                userRequest.value.plainPassword = null;
            }
            userStore
                .updateUser(router, userRequest.value, selectedUser.value.id)
                .then(() => {
                modalIsOpen.value = false;
                userStore.reset();
                page.value = 1;
                userStore
                    .getUsers(router, userQuery.value)
                    .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        (0, vue_3.watch)(modalIsOpen, (value) => {
            if (!value) {
                errorMessage.value = "";
            }
        });
        const userGroupCheckboxChange = (checked, userGroup) => {
            if (!checked) {
                userRequest.value.groups = userRequest.value.groups.filter((userGroupIri) => userGroupIri !== userGroup["@id"]);
                return;
            }
            let userGroupIri = userGroup["@id"];
            if (userGroupIri === undefined) {
                return;
            }
            userRequest.value.groups.push(userGroupIri);
        };
        const userGroupChecked = (userGroup) => {
            let userGroupIri = userGroup["@id"];
            if (userGroupIri === undefined) {
                return false;
            }
            return userRequest.value.groups.includes(userGroupIri);
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (openCreateUserModal()))
                    }, [
                        _hoisted_3,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("add_user_button", "Add User", "users")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((listFields).value = $event)),
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[3] || (_cache[3] = ($event) => ((sortDesc).value = $event)),
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event) => ((itemsPerPage).value = $event)),
                    items: (0, vue_2.unref)(userStore).users,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    "is-busy": (0, vue_2.unref)(userStore).loading,
                    pagination: "",
                    "total-items": (0, vue_2.unref)(userStore).totalUsers
                }, {
                    "cell-actions": (0, vue_2.withCtx)(({ item: user }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-primary btn-link",
                                onClick: ($event) => (openUpdateUserModal(user))
                            }, [
                                _hoisted_6,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("edit", "Edit", "users")), 1)
                            ], 8, _hoisted_5),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-danger btn-link",
                                onClick: ($event) => (deleteUser(user))
                            }, [
                                _hoisted_8,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("delete", "Delete", "users")), 1)
                            ], 8, _hoisted_7)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "items", "is-busy", "total-items"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    "is-open": modalIsOpen.value,
                    title: selectedUser.value !== null
                        ? _ctx.$trans('edit_user_modal_title', 'Edit User: {user}', 'users', {
                            user: selectedUser.value.email,
                        })
                        : _ctx.$trans('add_user', 'Add User', 'users'),
                    onClose: _cache[12] || (_cache[12] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: _ctx.$trans('save_error', 'Save error', 'users'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: userRequest.value.email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((userRequest.value.email) = $event)),
                            placeholder: _ctx.$trans('user_email_placeholder', 'User Email', 'users'),
                            label: _ctx.$trans('user_email_label', 'User Email', 'users'),
                            type: "email",
                            autofocus: "",
                            required: "",
                            class: "my-5",
                            border: ""
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: userRequest.value.plainPassword,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((userRequest.value.plainPassword) = $event)),
                            placeholder: _ctx.$trans('password_placeholder', 'Password', 'users'),
                            label: _ctx.$trans('password_label', 'Password', 'users'),
                            type: "password",
                            required: "",
                            autocomplete: false,
                            class: "my-5",
                            border: ""
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: plainPasswordConfirmation.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((plainPasswordConfirmation).value = $event)),
                            placeholder: _ctx.$trans('password_repeat_placeholder', 'Password repeat', 'users'),
                            label: _ctx.$trans('password_repeat_label', 'Password repeat', 'users'),
                            type: "password",
                            required: "",
                            autocomplete: false,
                            class: "my-5",
                            border: ""
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.TagInput), {
                            modelValue: userRequest.value.extraEmails,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((userRequest.value.extraEmails) = $event)),
                            "input-type": "email",
                            placeholder: _ctx.$trans('extra_email_addresses', 'Extra email addresses', 'users'),
                            label: _ctx.$trans('extra_email_addresses_label', 'Extra email addresses', 'users')
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: userGroupsListFields.value,
                            "onUpdate:fields": _cache[10] || (_cache[10] = ($event) => ((userGroupsListFields).value = $event)),
                            items: (0, vue_2.unref)(userGroupStore).userGroups,
                            striped: "",
                            condensed: "",
                            class: "mt-4",
                            "is-busy": (0, vue_2.unref)(userGroupStore).loading
                        }, {
                            "cell-actions": (0, vue_2.withCtx)(({ item: userGroup }) => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                                    checked: userGroupChecked(userGroup),
                                    onChange: checked => { userGroupCheckboxChange(checked, userGroup); }
                                }, null, 8, ["checked", "onChange"])
                            ]),
                            _: 1
                        }, 8, ["fields", "items", "is-busy"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-primary",
                                onClick: _cache[11] || (_cache[11] = ($event) => (selectedUser.value === null ? createUser() : updateUser()))
                            }, [
                                _hoisted_10,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("save", "Save", "users")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["is-open", "title"])
            ]));
        };
    }
});
